import { Sidebar } from 'components/Sidebar/Sidebar';
import React from 'react';
import { useLocation } from 'react-router-dom';

import './AdminView.scss';
import { AdminHeader } from 'components/Headers/AdminHeader/AdminHeader';
import { useViewVM } from '../useViewVM';

export type AdminViewProps = {
    render: React.ReactNode;
    headerTitle?: string;
    backButton?: boolean;
    backButtonLink?: string;
};

export const AdminView: React.FC<AdminViewProps> = ({ render, headerTitle = '', backButton = false, backButtonLink = "" }) => {
    const location = useLocation();

    // Fonction pour obtenir le nom de la page à partir de l'URL
    const getPageNameFromPath = () => {
        const path = location.pathname;
        const segments = path.split('/');
        const lastSegment = segments[segments.length - 1];

        // Gestion des cas spéciaux
        if (lastSegment === 'admin') return 'dashboard';
        if (lastSegment === 'persons' && path.includes('new')) return 'new-person';
        if (segments.includes('persons') && segments.length > 4) return 'person-details';

        return lastSegment;
    };

    const pageClassName = getPageNameFromPath();

    const { } = useViewVM({ render });
    return (
        <>
            <Sidebar />
            <div className={`renderer admin ${pageClassName}`}>
                <AdminHeader title={headerTitle} backButton={backButton} backButtonLink={backButtonLink} />
                {render}
            </div>
        </>
    );
};
